// ===================================
// BUNDLE DYNAMIC CALCULATOR V6.1
// Version HYBRIDE : Event listeners Kaching + DOM parsing
// - Utilise les events Kaching pour la quantité (fiable)
// - Parse le DOM pour le prix (plus fiable)
// - Initialisation au chargement
// - Fallback si Kaching ne charge pas
// ===================================

console.log('🚀 Bundle Dynamic Calculator V6.1 chargé');

// ===================================
// UTILITAIRES
// ===================================

function numberToEuro(cents) {
  if (typeof cents !== 'number' || !isFinite(cents)) {
    return '0,00€';
  }
  const euroValue = (parseInt(cents) / 100).toFixed(2).replace('.', ',') + '€';
  return euroValue;
}

function formatDurationMonths(months) {
  if (!Number.isFinite(months) || months < 0) {
    return '';
  }

  // Pour moins d'1 mois, afficher en semaines
  if (months < 1) {
    const weeks = Math.max(1, Math.round((months * 30) / 7));
    return `${weeks} semaine${weeks > 1 ? 's' : ''}`;
  }

  // Arrondi intelligent pour "X mois et demi"
  const integerPart = Math.floor(months);
  const decimalPart = months - integerPart;
  
  // Si la partie décimale est entre 0.25 et 0.75, afficher "et demi"
  if (decimalPart >= 0.25 && decimalPart <= 0.75) {
    if (integerPart === 1) {
      return '1 mois et demi';
    } else {
      return `${integerPart} mois et demi`;
    }
  }
  
  // Sinon, arrondir au mois entier le plus proche
  const rounded = Math.round(months);
  return `${rounded} mois`;
}

// ===================================
// RÉCUPÉRATION DES DONNÉES PRODUIT
// ===================================

function getProductData() {
  const bundleInfo = document.querySelector('.bundle-dynamic-info');
  if (!bundleInfo) {
    console.warn('⚠️ Element .bundle-dynamic-info non trouvé');
    return null;
  }

  const data = {
    durationDays: parseFloat(bundleInfo.dataset.durationDays) || 120,
    posologyBase: parseFloat(bundleInfo.dataset.posologyBase) || 0.5,
    weight: parseFloat(bundleInfo.dataset.weight) || 100,
    measureUnit: bundleInfo.dataset.measureUnit || 'g'
  };

  return data;
}

// ===================================
// RÉCUPÉRATION POSOLOGIE SÉLECTIONNÉE
// ===================================

function getSelectedPosology() {
  const selected = document.querySelector('.product-variant-advanced .option__item.selected');
  
  if (!selected) {
    console.warn('⚠️ Aucune posologie sélectionnée');
    return null;
  }

  if (!selected.dataset.quantity) {
    console.warn('⚠️ Pas de data-quantity sur la posologie');
    return null;
  }

  const data = {
    quantity: parseFloat(selected.dataset.quantity),
    name: selected.querySelector('.item__name span')?.textContent?.trim() || '',
    description: selected.querySelector('.item__description')?.textContent?.trim() || ''
  };

  return data;
}

// ===================================
// RÉCUPÉRATION BUNDLE (V6.0 HYBRIDE)
// ===================================

let cachedBundleData = null;

function getCachedBundleData() {
  return cachedBundleData;
}

// Fonction pour récupérer le bundle depuis le DOM (fallback)
function getSelectedBundleFromDOM() {
  console.log('🔍 Récupération bundle depuis le DOM...');
  
  // Trouver le radio coché
  const checkedInput = document.querySelector('.kaching-bundles input[type="radio"]:checked');
  
  if (!checkedInput) {
    console.warn('⚠️ Aucun bundle sélectionné');
    return null;
  }

  // Trouver le parent
  const barElement = checkedInput.closest('.kaching-bundles__bar') || 
                     checkedInput.closest('[class*="kaching"]') ||
                     checkedInput.parentElement;
  
  if (!barElement) {
    console.warn('⚠️ Element parent non trouvé');
    return null;
  }

  const textContent = barElement.textContent || '';
  console.log('📝 Texte du bundle:', textContent);

  // === RÉCUPÉRATION DE LA QUANTITÉ ===
  let quantity = null;
  
  // Méthode 1: Pattern "X + Y gratuit"
  const freePattern = /(\d+)\s*\+\s*(\d+)\s*gratuit/i;
  const freeMatch = textContent.match(freePattern);
  
  if (freeMatch) {
    const base = parseInt(freeMatch[1]);
    const free = parseInt(freeMatch[2]);
    quantity = base + free;
    console.log(`   ✅ Pattern "X + Y gratuit": ${base} + ${free} = ${quantity}`);
  }
  
  // Méthode 2: Parser "X pots" dans le texte (prioritaire sur data-quantity)
  if (!quantity) {
    const potMatch = textContent.match(/(\d+)\s*pot/i);
    if (potMatch) {
      quantity = parseInt(potMatch[1]);
      console.log('   ✅ Parsing "X pots":', quantity);
    }
  }
  
  // Méthode 3: data-quantity sur le radio
  if (!quantity && checkedInput.dataset.quantity) {
    const dataQty = parseInt(checkedInput.dataset.quantity);
    // Ne prendre que si c'est un nombre raisonnable (< 10)
    if (!isNaN(dataQty) && dataQty > 0 && dataQty < 10) {
      quantity = dataQty;
      console.log('   ✅ data-quantity:', quantity);
    }
  }
  
  // Fallback
  if (!quantity || isNaN(quantity)) {
    console.warn('   ⚠️ Aucune quantité trouvée, fallback à 1');
    quantity = 1;
  }
  
  console.log('   ✅ QUANTITÉ FINALE:', quantity);

  // === RÉCUPÉRATION DU PRIX ===
  let priceCents = 0;
  
  // Chercher tous les éléments qui peuvent contenir le prix
  const priceSelectors = [
    '[class*="price"]:not([class*="compare"])',
    '.price',
    '[class*="Prix"]',
    'strong',
    'span'
  ];
  
  let priceElement = null;
  for (const selector of priceSelectors) {
    const elements = barElement.querySelectorAll(selector);
    for (const el of elements) {
      const text = el.textContent || '';
      // Chercher un pattern prix (nombre suivi de €)
      if (/\d+[\s,\.]*€/.test(text) && !text.includes('économisez')) {
        priceElement = el;
        break;
      }
    }
    if (priceElement) break;
  }
  
  if (priceElement) {
    const priceText = priceElement.textContent;
    const cleanPrice = priceText
      .replace(/[^\d,\.]/g, '')
      .replace(',', '.');
    
    const priceFloat = parseFloat(cleanPrice || '0');
    priceCents = Math.round(priceFloat * 100);
    
    console.log('   💰 Prix détecté:', priceFloat, '€ =', priceCents, 'centimes');
  } else {
    // Fallback: chercher dans tout le texte
    const priceMatch = textContent.match(/(\d+(?:[,\.]\d+)?)\s*€/);
    if (priceMatch) {
      const priceStr = priceMatch[1].replace(',', '.');
      const priceFloat = parseFloat(priceStr);
      priceCents = Math.round(priceFloat * 100);
      console.log('   💰 Prix trouvé via regex:', priceFloat, '€ =', priceCents, 'centimes');
    }
  }

  const result = { quantity, priceCents };
  console.log('✅ Bundle DOM:', result);
  return result;
}

// ===================================
// MISE À JOUR ÉTAPE 2
// ===================================

function updateRecommendedQuantity() {
  const posology = getSelectedPosology();
  const etape2Container = document.querySelector('.etape-2-recommended');
  
  if (!etape2Container) {
    return;
  }

  if (!posology) {
    etape2Container.style.display = 'none';
    return;
  }

  const animalWeightEl = etape2Container.querySelector('.animal-weight');
  const quantityTextEl = etape2Container.querySelector('.quantity-text');

  if (animalWeightEl && posology.description) {
    animalWeightEl.textContent = posology.description;
  }

  if (quantityTextEl && posology.name) {
    quantityTextEl.textContent = posology.name.toLowerCase();
  }

  etape2Container.style.display = 'block';
}

// ===================================
// MISE À JOUR INFO BUNDLE
// ===================================

function updateBundleInfo() {
  console.log('🔄 Mise à jour bundle info...');
  
  const productData = getProductData();
  const posology = getSelectedPosology();
  const bundle = getCachedBundleData();
  
  const bundleInfoContainer = document.querySelector('.bundle-dynamic-info');
  
  if (!bundleInfoContainer) {
    console.warn('⚠️ Element .bundle-dynamic-info non trouvé');
    return;
  }

  if (!productData || !posology || !bundle) {
    bundleInfoContainer.style.display = 'none';
    console.warn('⚠️ Données manquantes pour le calcul');
    return;
  }

  // === CALCULS ===
  const totalSpoons = productData.durationDays * productData.posologyBase;
  const daysPerPot = totalSpoons / posology.quantity;
  const totalDays = daysPerPot * bundle.quantity;
  const totalMonths = totalDays / 30;
  const totalWeight = productData.weight * bundle.quantity;
  const dailyPrice = Math.round(bundle.priceCents / totalDays);

  console.log('🧮 Calculs:');
  console.log('   -', bundle.quantity, 'pots ×', productData.weight + productData.measureUnit, '=', totalWeight + productData.measureUnit);
  console.log('   - Durée:', Math.round(totalDays), 'jours =', totalMonths.toFixed(2), 'mois');
  console.log('   - Prix/jour:', (dailyPrice / 100).toFixed(2), '€');

  // === MISE À JOUR AFFICHAGE ===
  const weightEl = bundleInfoContainer.querySelector('.weight');
  const durationEl = bundleInfoContainer.querySelector('.duration-text, .duration');
  const priceEl = bundleInfoContainer.querySelector('.price');

  if (weightEl) {
    weightEl.textContent = `${totalWeight}${productData.measureUnit}`;
  }

  if (durationEl) {
    durationEl.textContent = formatDurationMonths(totalMonths);
  }

  if (priceEl) {
    priceEl.textContent = numberToEuro(dailyPrice);
  }

  bundleInfoContainer.style.display = 'block';
  console.log('✅ Affichage:', totalWeight + productData.measureUnit, '=', formatDurationMonths(totalMonths), '| Soit', numberToEuro(dailyPrice) + '/jour');
}

// ===================================
// FONCTION GLOBALE
// ===================================

function updateAllDynamicInfo() {
  updateRecommendedQuantity();
  updateBundleInfo();
}

// ===================================
// 🆕 EVENT LISTENERS KACHING (V6.0)
// ===================================

function initKachingEventListeners() {
  console.log('👂 Initialisation des event listeners Kaching...');
  
  // Attendre que le web component soit disponible
  const waitForKaching = setInterval(() => {
    const kachingBlock = document.querySelector('kaching-bundles-block');
    
    if (kachingBlock) {
      clearInterval(waitForKaching);
      console.log('✅ kaching-bundles-block trouvé');
      
      // Écouter l'événement variants-changed qui contient la quantité
      kachingBlock.addEventListener('variants-changed', (event) => {
        console.log('🎯 Event Kaching: variants-changed', event.detail);
        
        // Extraire la quantité totale
        const quantity = event.detail.variantIdQuantities
          .map((variant) => variant.quantity)
          .reduce((a, b) => a + b, 0);
        
        console.log('📦 Quantité depuis Kaching:', quantity);
        
        // Pour le prix, on va le chercher dans le DOM car l'event peut être unreliable
        // Récupérer le bundle complet depuis le DOM pour avoir le prix correct
        const bundleFromDOM = getSelectedBundleFromDOM();
        
        if (bundleFromDOM) {
          // Utiliser la quantité de Kaching mais le prix du DOM
          cachedBundleData = {
            quantity: quantity,
            priceCents: bundleFromDOM.priceCents
          };
          
          console.log('✅ Bundle mis en cache (hybride):', cachedBundleData);
        } else {
          // Fallback: utiliser les données de l'event
          let priceCents = 0;
          
          if (event.detail.price) {
            const priceString = event.detail.price;
            const priceFloat = parseFloat(priceString.replace(/[^\d,\.]/g, '').replace(',', '.'));
            priceCents = Math.round(priceFloat * 100);
            console.log('💰 Prix depuis event:', priceFloat, '€');
          }
          
          cachedBundleData = {
            quantity: quantity,
            priceCents: priceCents
          };
          
          console.log('✅ Bundle mis en cache (event):', cachedBundleData);
        }
        
        // Mettre à jour l'affichage
        setTimeout(() => {
          updateBundleInfo();
        }, 100);
      });
      
      // Écouter aussi l'événement deal-bar-selected
      kachingBlock.addEventListener('deal-bar-selected', (event) => {
        console.log('🎯 Event Kaching: deal-bar-selected', event.detail);
        
        // Récupérer le bundle depuis le DOM
        const bundle = getSelectedBundleFromDOM();
        if (bundle) {
          cachedBundleData = bundle;
          console.log('✅ Bundle depuis deal-bar-selected:', cachedBundleData);
        }
        
        // Attendre un peu pour que variants-changed soit déclenché
        setTimeout(() => {
          updateBundleInfo();
        }, 200);
      });
      
      console.log('✅ Event listeners Kaching initialisés');
      
      // 🆕 INITIALISATION AU CHARGEMENT
      // Récupérer le bundle sélectionné par défaut
      setTimeout(() => {
        if (!cachedBundleData) {
          console.log('🔄 Initialisation du bundle au chargement...');
          const initialBundle = getSelectedBundleFromDOM();
          if (initialBundle) {
            cachedBundleData = initialBundle;
            console.log('✅ Bundle initial:', cachedBundleData);
            updateBundleInfo();
          }
        }
      }, 500);
    }
  }, 100);
  
  // Timeout de sécurité
  setTimeout(() => {
    clearInterval(waitForKaching);
  }, 10000);
}

// ===================================
// INITIALISATION
// ===================================

function initBundleCalculator() {
  console.log('⚙️ Initialisation V6.1 hybride (Kaching + DOM)...');

  // ÉCOUTEURS POSOLOGIE
  const posologyOptions = document.querySelectorAll('.product-variant-advanced .option__item');
  
  if (posologyOptions.length > 0) {
    console.log(`✅ ${posologyOptions.length} options de posologie trouvées`);
    posologyOptions.forEach((option) => {
      option.addEventListener('click', () => {
        console.log('🐕 Posologie changée');
        setTimeout(updateAllDynamicInfo, 150);
      });
    });
  }

  // 🆕 EVENT LISTENERS KACHING
  initKachingEventListeners();

  // FALLBACK: Écouteurs classiques sur le bundle (au cas où Kaching events ne marchent pas)
  const bundleContainer = document.querySelector('.kaching-bundles');
  
  if (bundleContainer) {
    // Changement de radio dans le bundle
    bundleContainer.addEventListener('change', (e) => {
      if (e.target.type === 'radio') {
        console.log('📻 Radio changé dans le bundle (fallback)');
        const bundle = getSelectedBundleFromDOM();
        if (bundle) {
          cachedBundleData = bundle;
          setTimeout(updateBundleInfo, 100);
        }
      }
    });
    
    // Clic sur une barre du bundle
    bundleContainer.addEventListener('click', (e) => {
      const bar = e.target.closest('.kaching-bundles__bar');
      if (bar) {
        console.log('🖱️ Clic sur une barre du bundle (fallback)');
        setTimeout(() => {
          const bundle = getSelectedBundleFromDOM();
          if (bundle) {
            cachedBundleData = bundle;
            updateBundleInfo();
          }
        }, 200);
      }
    });
  }

  // MISE À JOUR INITIALE (après un délai pour laisser Kaching charger)
  setTimeout(() => {
    console.log('🔄 Mise à jour initiale...');
    
    // Si pas encore de bundle en cache, le récupérer du DOM
    if (!cachedBundleData) {
      const initialBundle = getSelectedBundleFromDOM();
      if (initialBundle) {
        cachedBundleData = initialBundle;
        console.log('✅ Bundle initial (DOM):', cachedBundleData);
      }
    }
    
    updateAllDynamicInfo();
  }, 1000);

  console.log('✅ V6.1 initialisée');
}

// ===================================
// DÉMARRAGE
// ===================================

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBundleCalculator);
} else {
  initBundleCalculator();
}

// ===================================
// DEBUG (optionnel)
// ===================================

window.debugBundle = {
  getBundle: getCachedBundleData,
  getBundleFromDOM: getSelectedBundleFromDOM,
  getPosology: getSelectedPosology,
  getProduct: getProductData,
  update: updateBundleInfo,
  updateAll: updateAllDynamicInfo,
  cachedData: () => cachedBundleData
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    updateRecommendedQuantity,
    updateBundleInfo,
    updateAllDynamicInfo,
    getProductData,
    getSelectedPosology,
    getCachedBundleData
  };
}
